<template>
    <div>       
        <div class="w-full flex flex-col">
            <div class="modal-header flex items-center justify-between cursor-move">
                <h1 class="flex-1 text-2xl">Edit Expense</h1>
                <div @click="$modal.hide('edit-proposal-expense')">
                    <inline-svg name="close" classes="w-5 h-5 text-white fill-current cursor-pointer"></inline-svg>
                </div>
            </div>
		    <div class="p-5 flex items-center gap-x-8">
			    <div>
			        <label for="type">Type</label>
			        <select v-model="selectedProposalExpense.type_id" class="mt-1 form-select min-w-fit">
			        	<option value=""></option>
			        	<option v-for="type in expenseTypes" :key="type.id" :value="type.id">{{ type.name }}</option>
			        </select>
			        <div v-if="errors.type_id" class="form-error">{{ errors.type_id[0] }}</div>
			    </div>

		        <div>
					<label for="expense_amount">Amount PSF</label>
					<currency-input v-model="selectedProposalExpense.amount_in_dollars" :size="11" name='expense_amount' is-decimal></currency-input>
					<div v-if="errors.amount" class="form-error">{{ errors.amount[0] }}</div>
		        </div>		

			    <div>
			        <label for="type">Base or Net</label>
			        <select v-model="selectedProposalExpense.base_net_included" class="mt-1 form-select min-w-fit">
			        	<option value=""></option>
			        	<option value="Base">Base</option>
			        	<option value="Net">Net</option>
			        	<option value="Included">Included</option>
			        </select>
			        <div v-if="errors.base_net_included" class="form-error">{{ errors.base_net_included[0] }}</div>
			    </div>
			</div>
            <div class="bg-gray-100 p-4">
                <div class="flex items-center justify-end">
                    <button class="btn btn-secondary mr-2" @click.prevent="$modal.hide('edit-proposal-expense')">Close</button>
                    <div>
                        <button class="btn btn-green" @click.prevent="saveExpense">
                            <span v-if="loading">
                                <inline-svg name="loading-button"></inline-svg>                                
                            </span>
                            <span v-if="! loading">Save Expense</span>
                        </button>
                    </div>
                </div>
            </div>
		</div>
		<notifications classes="notification" position="bottom right"></notifications>
	</div>
</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    
    export default {
        data() {
            return { 
            	expenseTypes: {},
            	loading: false
            }
        },

        mounted() {
            axios.get('/api/expense-types').then((response) => {
				this.expenseTypes = response.data;
			}).catch((error) => {
                this.$notify({
                    type: 'error',
                    title: 'Error',
                    text: 'Error pulling Expense Types, please try again later'
                });
           	});
        },

        computed: {
            ...mapState(['projects']),
            ...mapState(['proposals']),
            ...mapGetters(['selectedProposal']),
            ...mapGetters(['selectedProposalExpense']),

            errors() {
            	return this.proposals.errors;
            }
        },

        methods: {
            async saveExpense() {
                this.loading = true;

                await this.$store.dispatch('saveExpense').then(() => {
                    this.loading = false;

                    this.$notify({
                        type: 'success',
                        title: 'Success',
                        text: "Expense Saved"
                    });

                    this.$emit('save-proposal');

                    this.$forceUpdate();

                    this.$modal.hide('edit-proposal-expense');
                });
            }
        }
    }
</script>